// Suspend an admin account. Suspension is a security action — every
// surface that reads the admin row (list, summary, audit) needs to
// refresh.

import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { suspendAdmin } from '../adminsEndpoints'
import { adminsQueryKeys } from '../adminsQueryKeys'

export function useSuspendAdminMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => suspendAdmin(id),
    onSuccess: (_, id) => {
      qc.invalidateQueries({ queryKey: adminsQueryKeys.lists() })
      qc.invalidateQueries({ queryKey: adminsQueryKeys.audit(id) })
    },
  })
}
